module.exports = __webpack_public_path__ + "static/media/logo_dark_small.d394a848.png";